import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import Header from '~/components/Header'
import WebPhoneIframe from '~/components/WebPhoneIframe'

import { Wrapper } from './styles'

export default function DefaulLayout({ children }) {
  const profile = useSelector((state) => state.user.profile)

  return (
    <Wrapper>
      {profile.dominio === 'cloud.cloudcom.com.br' && <WebPhoneIframe />}
      <Header />
      {children}
    </Wrapper>
  )
}

DefaulLayout.propTypes = {
  children: PropTypes.element.isRequired,
}
